import { pluralize } from '#shared/lib/string';

export function formatMoveBackwardAvailableForSeconds(totalSeconds: number): string {
    if (totalSeconds <= 0) {
        return '';
    }

    const days = Math.floor(totalSeconds / 86400);

    return pluralize(days, '%d дня', '%d дней', '%d дней');
}
